export const canSearch = (props: { prefectureIds: string[] | null | undefined }): boolean => {
  return props.prefectureIds != null && props.prefectureIds.length > 0;
};
